/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:grid;grid-template-rows:auto -webkit-max-content -webkit-max-content auto;grid-template-rows:auto max-content max-content auto}label[_ngcontent-%COMP%]:nth-of-type(1){grid-row:2;color:#ff691f;font-size:12px;font-weight:600}label[_ngcontent-%COMP%]:nth-of-type(1)   span[_ngcontent-%COMP%]{color:#1bb95e;font-size:10px;font-weight:400}label[_ngcontent-%COMP%]:nth-of-type(2){grid-row:3;margin-top:2px;color:#fff;font-size:12px;font-weight:400}"];
export { styles as styles };
